<template>
  <footer class="mrt__footer">
    <p>Open API from Metro Taipei</p>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
$charcoal: #434a42;
footer {
  width: 100vw;
  background-color: $charcoal;
  color: white;
  font-size: 14px;
  padding: 15px 0;
  // position: absolute;
  // bottom: 0;
  text-align: center;
}

</style>